import { render } from "./OffscreenHotspotsIndicator.vue?vue&type=template&id=a03199dc"
import script from "./OffscreenHotspotsIndicator.js?vue&type=script&lang=js"
export * from "./OffscreenHotspotsIndicator.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__